import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar, LineClamp } from '../../../global/commonStyle';

const NavbarMain = styled.div`
  padding-top: var(--space-12);
  max-width: 210px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  background-color: var(--background-navbar);
  ${HideScrollbar}
  .blank-div-click {
    display: none;
  }
  ${mobile_xl(css`
    max-width: 100%;
    height: 100dvh;
    gap: var(--space-0);
    padding: var(--space-0);
    background-color: var(--background-secondary);
    .blank-div-click {
      display: flex;
      position: absolute;
      width: 20px;
      height: 20px;
      z-index: var(--z-index-99999);
      opacity: 0;
    }
  `)}
`;

const MenuSectionDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  ${mobile_xl(css`
    padding-top: var(--space-4);
    gap: var(--space-6);
    width: 100%;
  `)}
`;
const Menu = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  ${mobile_xl(css`
    padding-inline: var(--space-12);
  `)}
`;

const Submenu = styled.div`
  ${mobile_xl(css`
    /* for help and support option */
    .help-support-dropdown {
      padding: var(--space-11) var(--space-12) var(--space-11) var(--space-8);
    }
    svg {
      margin: var(--space-0);
    }
    .reference-item {
      padding-inline: var(--space-0);
    }
    .dropdown-item {
      padding: var(--space-0);
      &:hover {
        background-color: unset;
      }
      p {
        font-weight: 500;
      }
    }
  `)};
`;

const ProfileMenu = styled.div`
  padding: var(--space-11) var(--space-12) var(--space-11) var(--space-8);
  ${FlexBetween}
  gap: var(--space-8);
`;

const LHS = styled.div`
  p {
    width: 145px;
    margin: var(--space-0);
    ${Typography.body_xl_medium}
    color: var(--text-primary)
  }
  &.log-out {
    p {
      color: var(--accent-error);
    }
  }
`;

const RHS = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  p {
    width: 100%;
    margin: var(--space-0);
    ${Typography.body_md}
    color: var(--text-secondary);
    ${LineClamp(1)}
    word-break: break-all;
  }
`;

const IconDiv = styled.div`
  ${FlexCenter}
`;

const IconView = styled.div`
  position: absolute;
  left: -2px;
  ${mobile_xl(css`
    left: 0;
  `)}
`;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding-inline: var(--space-12);
  &.bottom-div {
    margin-bottom: var(--space-24);
    ${mobile_xl(css`
      margin-bottom: var(--space-96);
      padding: var(--space-0);
    `)}
  }
  ${mobile_xl(css`
    gap: var(--space-4);
    padding: var(--space-0);
  `)}
`;

const Line = styled.div`
  display: none;
  ${mobile_xl(css`
    display: block;
    border-bottom: 0.5px solid var(--border-primary);
  `)}
`;

const Icon = styled.div`
  ${FlexCenter}
  ${mobile_xl(css`
    .svg-icon {
      width: 20px;
      height: 20px;
    }
  `)}
`;

const LogoutMenu = styled.div`
  padding: var(--space-11) var(--space-12) var(--space-11) var(--space-8);
  ${AlignCenter}
  gap: var(--space-8);
`;

const IconWrapper = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
`;
export {
  NavbarMain,
  Menu,
  Submenu,
  IconView,
  Div,
  MenuSectionDiv,
  Line,
  ProfileMenu,
  LHS,
  RHS,
  IconDiv,
  Icon,
  LogoutMenu,
  IconWrapper
};
